// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0b25cab2","338":"37c5c498","427":"d44ecf63","564":"a1de3a25","695":"4fb09c99","703":"0394d409","770":"24d9c2a8","787":"be814a04","945":"37d79d17"}[chunkId] + ".chunk.js";
};